import { FunctionComponent } from 'react';
import { first } from 'es-toolkit/compat';

import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import ImageSelectQuizQuestion from 'components/profile/quiz/ImageSelectQuizQuestion';
import MultiImageSelectQuizQuestion from './MultiImageSelectQuizQuestion';
import SliderQuizQuestion from 'components/profile/quiz/SliderQuizQuestion';
import TextSelectQuizQuestion from 'components/profile/quiz/TextSelectQuizQuestion';

export interface Props {
  question: consumer.IPatronQuizQuestion;
  selectedOptionId?: number[];
  onAnswer(optionId: number[]): void;
}

const QuizQuestion: FunctionComponent<Props> = (props) => {
  let body: JSX.Element;
  switch (props.question.questionType) {
    case undefined:
    case 'TEXT_SELECT': {
      body = <TextSelectQuizQuestion {...props} selectedOptionId={first(props.selectedOptionId)} />;
      break;
    }
    case 'IMAGE_SELECT': {
      body = (
        <ImageSelectQuizQuestion {...props} selectedOptionId={first(props.selectedOptionId)} />
      );
      break;
    }
    case 'MULTI_SELECT': {
      body = (
        <MultiImageSelectQuizQuestion
          {...props}
          onAnswer={(optionIds: Set<number>) => props.onAnswer(Array.from(optionIds))}
          selectedOptionId={new Set(props.selectedOptionId)}
        />
      );
      break;
    }
    case 'SLIDER': {
      body = <SliderQuizQuestion {...props} selectedOptionId={first(props.selectedOptionId)} />;
      break;
    }
    default: {
      return null;
    }
  }
  return (
    <>
      <div className="QuizModal-questionText">
        <Typography color="inherit" component="span" variant="body02Strong">
          {props.question.displayText}
        </Typography>
      </div>
      {props.question.imageUrl ? (
        <img src={props.question.imageUrl} alt="Decoration" className="QuizModal-questionImage" />
      ) : null}
      {body}
    </>
  );
};

export default QuizQuestion;
